import React, { Component } from 'react';
import MarkupConversion from '../../../Components/MarkupConversion';
import http from '../../../services/http';
import ProfileService from '../../../services/ProfileService';
import { conditionRulesChecking, isSet } from '../../../Utils/CommonFunctions';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import * as actions from '../../../store/actions';
import { setErrorListAction, showErrorDetailsAction } from '../../../store/actions/ErrorSetupAction';
import { loadPageConfigCollectionAction, removeActivePopupPageAction, updatePageFlowsDataAction,setPagesHistoryConfigAction } from '../../../store/actions/PagesAction';
import BackgroundActionInputModal from '../../LayoutContainer/BackgroundActionInputModal';
import { createPortal } from 'react-dom';
class PagesRenderComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
        formPayload:{},
        isbackgroundProcess:false,
        toEmail: null,
        reminderAlert: null,
        pendingAutomation: null
    };
  }
  wrapperDom = document.querySelector('.wrapper');
  componentDidMount = ()=>{
    const {pagesConfigData} = this.props;
    if(pagesConfigData!==null){
        this.fetchVariablesList();
    }
  }
  componentDidUpdate = (prevProps)=>{
     const {pagesConfigData} = this.props;
    if(pagesConfigData!==null && prevProps.pagesConfigData?.id!==pagesConfigData?.id){
        this.fetchVariablesList();
    }
  }
  fieldOnChangeHandler = (obj,val)=>{
    // const { pageFlows,  resourcesList} = this.props;
    // const automationPageDetails = pageFlows?.pageData[apiName];
    // const fromMapping = automationPageDetails?.from_page_mapping;
    // const toMapping = automationPageDetails?.to_page_mapping;
    // console.log('resourcesList',obj,fromMapping);
    // console.log("obj val ,",obj , val );
   this.setState({
        formPayload:{
            ...this.state.formPayload,
            [  obj.variable_name || obj.api_name]:{
                ...obj,
               selected_value:val
            }
        }
    });
    // const inputMap = Object.fromEntries(
    //         resourcesList['input'].map(item => [item.id, obj.api_name])
    // );
    // console.log('inputMap',resourcesList,inputMap);
    // fromMapping.map(item => {
    //         // const apiName = inputMap[item.pages_variable_id];
    //         // const selectedValue = apiName ? formPayload[apiName]?.selected_value : undefined;
    //         return {
    //             ...item,
    //             selected_value: val
    //         };
    //     });
  }

  // Handle background modal submit with toEmail
  toggleBackgroundProcessModel = (data = {}, toFieldMapping = {}, backgroundParams = {}) => {
    console.log('Background modal closed. backgroundParams:', backgroundParams);
    if (Object.keys(backgroundParams).length > 0) {
      this.setState({
        isbackgroundProcess: false,
        toEmail: backgroundParams.toUserEmailIds,
        reminderAlert: backgroundParams.reminderAlert
      }, () => {
        this.executeAutomationWithEmail();
      });
    } else {
      // User cancelled modal
      this.setState({
        isbackgroundProcess: false,
        toEmail: null
      });
      this.props.Loader(false);
    }
  }

  // Store pending automation data
  storePendingAutomation = (automationPageDetails, updatePayload, fromMapping, toMapping) => {
    this.setState({
      pendingAutomation: {
        automationPageDetails,
        updatePayload,
        fromMapping,
        toMapping
      }
    });
  }

  // Execute automation with email parameter
  executeAutomationWithEmail = () => {
    this.props.Loader(true);
    const { pendingAutomation, toEmail, reminderAlert } = this.state;
    const { automationPageDetails, updatePayload, fromMapping, toMapping } = pendingAutomation || {};
  
    if (!automationPageDetails) {
      console.error('No automation found');
      this.props.Loader(false);
      return;
    }
    
    // Build URL with toEmail parameter
    let url = `pageconfig/${automationPageDetails.id}/pages-config-execute`;
    if (toEmail) {
      url += `?toUserEmailIds=${toEmail}`;
      if (reminderAlert !== undefined) {
        url += `&reminderAlert=${reminderAlert}`;
      }
    }

    // console.log('Executing with URL:', url);
    this.executeAPI(automationPageDetails, updatePayload, fromMapping, toMapping, url,true);
  }

   toPagesRulesCheck = (rules,outputResponse)=>{

      let validationResult ='(true===true)';
      if(rules.length>0){
        validationResult+=' && (';
      }
      rules.forEach((rule,ruleIndex)=>{
        const conditionField = {
            isExist:isSet(outputResponse['pages_message'],null)!==null?true:false,
            field:{type:'TextInput',...outputResponse['pages_message'],selectedValue:outputResponse['pages_message']?.value},
            selectedValue:outputResponse['pages_message']?.value}
        if(conditionField.isExist===true){
          if(ruleIndex>0){
            if(isSet(rule.logical_operator,'')==='AND'){
              validationResult+=' &&';
            }else if(isSet(rule.logical_operator,'')==='OR'){
              validationResult+=' || ';
            }
          }
        //   console.log('filter',isSet(rule.filter_name,'equal to'));
          validationResult+=' (true==='+conditionRulesChecking(
            conditionField,
            {values:rule.value,filter:isSet(rule.filter_name,'is not empty')})+' )';
            
        }else{
          if(ruleIndex>0){
            validationResult+=' &&';
          }
          validationResult+='(true===false)';
        }
      });
      if(rules.length>0){
        validationResult+=')';
      }
    //   console.log('conditionField',validationResult);
      try{
        if(eval("("+validationResult+")")){
          return true;
        }
      }catch(e){
  
      }
      return false;
   }
   executeAPI=(automationPageDetails, updatePayload, fromMapping, toMapping,url,isbackgroundProcess=false,isSamePage=false)=>{
    try{
    this.props.Loader(true);
	  http.POST(url, updatePayload)
		.then(async (response) => {
      this.props.Loader(false);
			const responseData = response.data;
			if (responseData.code === 200) {
				const resData = responseData.data;
         if(isbackgroundProcess){
          this.props.removeActivePopupPageAction(this.props.currentPage);
          this.props.warningMessage(responseData.message)
          return
        }
				let outputResponse = {};
                // console.log('automationPageDetails',automationPageDetails?.automation_type==='API');
                let variables = isSet(resData.variables,[]);
                if(automationPageDetails?.automation_type==='API'){
                    // console.log('resData',resData);
                    isSet(resData,[]).forEach((rData)=>{
                        variables = [...variables,...isSet(rData.variables,[])];
                    })
                }
				try {
					variables.forEach((v) => {
						outputResponse = {
							...outputResponse,
							[isSet(v.api_name,v.apiName)]: v
						}
					});
				} catch (e) {}
                //  this.props.Loader(false);
                // console.log('variables',variables);
				let outputErrorMsg = outputResponse?.Error_messages?.value;
				if ((responseData.messages !== undefined && responseData.messages.length > 0) || isSet(outputErrorMsg, []).length > 0) {
					let errorMessageList = isSet(responseData.messages, isSet(outputErrorMsg, []), 'ARRAY');
					// console.log('errorMessageList',errorMessageList);
					this.props.setErrorListAction(errorMessageList);
					if (!this.props.isErrorModalOpen) {
                        this.props.Loader(false);
						this.props.showErrorDetailsAction();
					}
				}
				let isConditionTrue = false;
        let pageId=null;
				toMapping && toMapping.forEach((toMap) => {
                    console.log('toMap?.condition, outputResponse',toMap?.condition, outputResponse);
					const isTrue = this.toPagesRulesCheck(toMap?.condition, outputResponse);
                    console.log('isTrue',isTrue);
					if (isTrue === true) {
						isConditionTrue = true;
						const valuesArray = variables;
						let toFieldMapping = toMap?.field_mappings.map((mField) => {
							const result = valuesArray?.find(i => i.id === mField.automation_variable_id);
                                if (result) {
                                    let parsedValue = isSet(result.value,'');
                                    // console.log('parsedValue',result,parsedValue);
                                    try {
                                        // Try to parse JSON if it's a string
                                        if (typeof result.value === 'string') {
                                            parsedValue = JSON.parse(result.value);
                                        }
                                    } catch (e) {
                                        // Ignore parsing error, keep original value
                                    }

                                    return {
                                        ...mField,
                                        value: parsedValue
                                    };
                                }
						});
						let toFieldMappingOutputs = {};
                        // console.log('toFieldMapping',toFieldMapping);
						try {
							toFieldMapping.forEach((v) => {
								toFieldMappingOutputs = {
									...toFieldMappingOutputs,
									[v.pages_variable_name]: v?.value
								}
							});
						} catch (e) {

						}
						// console.log('automationPageDetails',automationPageDetails?.configuration_api_name);
            if(!isbackgroundProcess){
              pageId=toMap?.page_id;
              if(isSamePage){
                pageId= this.props.pagesConfigData?.pages?.id;
              }              
              this.fetchPageDetails(pageId, automationPageDetails?.configuration_api_name, toFieldMappingOutputs);
            }
						// console.log(toMap?.page_id, toMap?.field_mappings, valuesArray, toFieldMappingOutputs);
					}
				});
				if (isConditionTrue === false) {
					this.props.Loader(false);
				}

				// console.log('outputResponse',JSON.stringify(outputResponse));

			} else {
				this.props.Loader(false);
			}
		}, (error) => {
      this.props.Loader(false);
			console.log(error);
			//  this.setState({
			//   isMappingDDLoading:false
			// })
		})  
    } catch (error) {
      console.error("Error in executeAPI:", error);
    }
   }
  onSubmitAutomationHandler = async (apiName) => {
    try{
    const { formPayload } = this.state;
    const { pageFlows, resourcesList } = this.props;
    const automationPageDetails = pageFlows?.pageData[apiName];

    const fromMapping = automationPageDetails?.from_page_mapping;
    const toMapping = automationPageDetails?.to_page_mapping;
    const isSamePage = automationPageDetails?.is_same_page || false;
    const isbackgroundProcess = automationPageDetails?.is_same_page ? false : automationPageDetails?.is_background_process;

    if (automationPageDetails?.id) {
        try {
            const hasPermission = await ProfileService.checkPagesConfigurationPermission(automationPageDetails.id);
            if (!hasPermission) {
                if (typeof this.props?.warningMessage === 'function') {
                    this.props.warningMessage("You don't have permission to access this page. Please contact your administrator.");
                }
                this.props.Loader(false);
                return;
            }
        } catch (permissionError) {
            console.error("Permission check failed:", permissionError);
            this.props.Loader(false);
            return;
        }
    }
 
    this.setState({
      isbackgroundProcess: isbackgroundProcess
    })

    const inputMap = Object.fromEntries(
      resourcesList['input'].map(item => [item.id, item.api_name])
    );
    // console.log(" input =", inputMap);
    const url = `pageconfig/${automationPageDetails.id}/pages-config-execute`;
    const updatePayload = fromMapping.map(item => {
      const apiName = isSet(item?.pages_variable_name, inputMap[item.pages_variable_id]);

      const selectedValue = apiName ? formPayload[apiName]?.selected_value : undefined;
      return {
        ...item,
        selected_value: isSet(selectedValue, ''),
      };
    });
    // console.log("selected alue==" ,selectedValue);


    // If background process enabled, show modal to get email
    if (isbackgroundProcess) {
      this.props.Loader(false);
      this.storePendingAutomation(automationPageDetails, updatePayload, fromMapping, toMapping);
      return;
    }

    this.executeAPI(automationPageDetails, updatePayload, fromMapping, toMapping, url,isbackgroundProcess,isSamePage,)
    }catch(error){
      console.error("Error in onSubmitAutomationHandler:", error);
      this.props.Loader(false);
    }
  }

  render() {
    const {composedHtml,pagesConfigData,resourcesList} = this.props;
    const { isbackgroundProcess } = this.state;
    
    // const valuesArray = Object.values(formPayload)
    // console.log('formPayload-1',resourcesList['input']);
    // console.log('resourcesList',this.props.pageFlows);
    // console.log('pagesConfigData',pagesConfigData?.pages?.display_type==='POPUP');
    return(
        <>
           {
           isbackgroundProcess && this.wrapperDom !== null &&
          createPortal(
            <BackgroundActionInputModal
              modelHandler={this.toggleBackgroundProcessModel}
              zIndex="2000"
            />,
            this.wrapperDom
          )
        }
        {composedHtml && (
            <MarkupConversion 
                resourcesList={resourcesList['input']}
                outputResponse={this.props.outputResponse }
                onSubmitAutomationHandler={this.onSubmitAutomationHandler}
                fieldFormPayload={this.state.formPayload}
                onChangeResourcesFieldHandler={(obj,val)=>this.fieldOnChangeHandler(obj,val)}
                htmlContent={composedHtml} />
                    )}
        </>
    )
  }
   fetchVariablesList = () => {
        const {pagesConfigData} = this.props;
        // console.log('pageData',pageData);
        // let automationType = pageData.automation_type;
        // if(pageData.automation_type==='RATINGS'){
        //     automationType = 'HYPERTHREAD';
        // }
        // this.setState({
        //   isMappingDDLoading:true
        // })
        http.GET(`pages-variable/paginated-search?pageConfigurationId=${pagesConfigData.id}&search=&page=0&orderBy=&size=1000`)
            .then(async (response) => {
            //    this.setState({
            //     isMappingDDLoading:false
            //   })
                // console.log('response',response);
                const responseData = response.data;
                if (responseData.code === 200) {
                    const data = responseData.data;
                    console.log('variableList',data);
                    let inputVariables = [];
                    let outputVariables = [];
                    // isSet(data, []).map((item) => {
                    //   if(automationType==='STEPS'){
                    //      inputVariables.push({...item,fields:[]});
                    //      outputVariables.push({...item,fields:[]});
                    //   }else{
                    //     if(item.is_request===true){
                    //         // if (item.fieldtype_name === 'Object' || item.fieldtype_name === 'Array' || item.fieldtype_name === 'Messages') {
                    //         //     item.fields = [];
                    //         // }
                    //         inputVariables.push({...item,fields:[]});
                    //     }else if(item.is_response===true){
                    //         outputVariables.push({...item,fields:[]});
                    //     }
                    //   }
                        
                    //         // global_variables.push(item);
                    // });
                    // console.log(" responses-==" , inputVariables);
                    //  this.props.setResourcesListAction({
                    //     variables: data,
                    //     input:inputVariables,
                    //     output:outputVariables
                    // });

                    // isSet(global_variables, []).map((item) => {
                        // if (isSet(item.window_id, null) !== null) {
                        //     generateWindowFields(item.window_id);
                        // }
                        // if (item.fieldtype_name === 'Object' || item.fieldtype_name === 'Array' || item.fieldtype_name === 'Messages') {
                        //     fetchArrayObjectVariables(item);
                        // }
                    // })

                }else{
                  
                    // this.props.setResourcesListAction({
                    //     variables: [],
                    //     input:[],
                    //     output:[]
                    // });
                }
            }, (error) => {
                console.log(error);
                //  this.setState({
                //   isMappingDDLoading:false
                // })
            })

    }

    fetchPageDetails = (pageId,configApiName,toFieldMapping)=>{
         http.GET(`pages/search-by-id/${pageId}`)
            .then(async (res) => {
                this.props.Loader(false);
                if (res.status === 200) {
                    const response = res.data;
                    if (response.code === 200) {
                        console.log('response?.data',response?.data);
                        const resData = response?.data;
                        if(resData?.display_type==='SAME_WINDOW'){
                            // console.log('window.opener',window.opener);
                            // if (window.opener) {
                                // window.opener.postMessage(
                                //     {
                                //     type: "NAVIGATE",
                                //     path: `/pages/page/${resData?.id}`
                                //     },
                                //     "*"
                                // );
                                // window.close(); // close only the popup
                                // } else {
                                // fallback: if opened normally, navigate in child
                                this.props.setPagesHistoryConfigAction();
                                this.props.history.push(`/pages/page/${resData?.id}`);
                                // }
                            //  this.props.history.push(`/pages/page/${resData.id}`);
                            //  console.log('window.opener',window.opener);
                             if(this.props.pageType==='POPUP'){
                                this.props.removeActivePopupPageAction(this.props.currentPage);
                             }
                            //  else if(this.props.pageType==='SEPARATE_WINDOW'){
                            //     window.close();
                            //  }
                        }else if(resData?.display_type==='SEPARATE_WINDOW'){
                                // console.log('resData',resData);
                                const url = `/pages/window/${resData?.id}`;
                                const {format,width,height} = resData;
                                let screenwidth = 800;
                                let screenheight = 600;
                                if(format==="CUSTOM"){
                                screenwidth = width;
                                screenheight = height;
                                }
                                // console.log('pages',pages);
                                if(window.opener){window.close();}
                                const childWindow1 = window.open(
                                    url,
                                    resData.page_name, // window name
                                    `width=${width},height=${height},top=100,left=100,resizable=no,scrollbars=yes,location=no,status=no`
                                );
                                //  childWindow.sharedHistoryPush = (path) => {
                                //   console.log('pages....');
                                //   history.push(path); // parent navigates
                                // };
                                this.props.setPagesHistoryConfigAction();
            
                        }else{
                            this.props.removeActivePopupPageAction(this.props.currentPage);
                        }
                        
                        this.props.loadPageConfigCollectionAction({
                            pages:response?.data,
                            type:'PAGES',
                            outputVariables:toFieldMapping,
                        },'ID',response?.data.id)
                        // console.log('response',response?.data,toFieldMapping);
                        // this.props.updatePageFlowsDataAction(configApiName,'toOutputPages',{
                        //     pages:response?.data,
                        //     outputVariables:toFieldMapping
                        // });
                        // this.setState({ pageConfigData: response.data });
                    } else {
                        // this.props.failMessage(response.message);
                    }
                }
            }, (error) => {
                // this.props.Loader(false);
                // this.props.failMessage('Error occured while save profile');
            })
    }
}


const mapDispatchToProps = dispatch => {
    return {
        Loader: (bool) => dispatch(actions.loader(bool)),
        succMessage: (msg) => dispatch(actions.succMessage(msg)),
        failMessage: (msg) => dispatch(actions.failMessage(msg)),
        warningMessage: (msg) => dispatch(actions.warningMessage(msg)),
        setErrorListAction:(val)=>dispatch(setErrorListAction(val)),
        showErrorDetailsAction:(val)=>dispatch(showErrorDetailsAction()),
        updatePageFlowsDataAction:(a,b,c)=>dispatch(updatePageFlowsDataAction(a,b,c)),
        loadPageConfigCollectionAction:(by,val,history)=>dispatch(loadPageConfigCollectionAction(by,val,history)),
        removeActivePopupPageAction:(payload)=>dispatch(removeActivePopupPageAction(payload)),
        setPagesHistoryConfigAction:()=>dispatch(setPagesHistoryConfigAction())
        // clearPagesConfiguration:()=>dispatch(clearPagesConfiguration())
    };
}
const mapStateToProps = (state) => { 
  return {
    //   fromMappingFields:state.PagesReducer.pagesConfiguration.from_page_mapping,
      resourcesList:state.PagesReducer.resourcesList,
      activePage:state.PagesReducer.activePage,
      pageFlows:state.PagesReducer.pageFlows,
  };
}
export default
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(withRouter(PagesRenderComponent));
